import {EventBus} from "@/utilities/event-bus";
import axios from "axios";
import {SettingsContext} from "@/utilities/settings-context";
import { generalError} from "@/functions/system-modal-functions";
import { PromotionType } from "@/states/promotion-state";

export async function confirmPromotion(id: number): Promise<boolean> {

    return new Promise<boolean>( (resolve) => {

        EventBus.$emit('confirm-promotion', {id, callback: (result: boolean) => resolve(result)});
    });
}

export function onConfirmPromotion(callback: (args: {id: number; callback: (result: boolean) => void}) => void) {

    EventBus.$on('confirm-promotion', callback);
}

export async function promote(ad: {id: number}, promotionType: PromotionType, callback: (() => Promise<void>) | null = null) {

    if(promotionType === 'none') {
        return false;
    }

    try {

        await axios.post(SettingsContext.getApiUrl('SelectPlan') + `/${ad.id}`, {promotionType});

        if (callback != null) {

            await callback();
        }

        return true;
    }
    catch
    {
        await generalError(false);

        return false;
    }
}
